import { render, staticRenderFns } from "./SubFamiliasManager.vue?vue&type=template&id=eeecf2b0&scoped=true"
import script from "./SubFamiliasManager.vue?vue&type=script&lang=js"
export * from "./SubFamiliasManager.vue?vue&type=script&lang=js"
import style0 from "./SubFamiliasManager.vue?vue&type=style&index=0&id=eeecf2b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeecf2b0",
  null
  
)

export default component.exports